<template>
  <v-container fluid>
    <v-row justify="center">
      <v-form
          ref="queryForm"
          style="width:90%;"
      >
        <v-row
            align="center"
            justify="center">
          <v-col
              cols="2">
            <v-text-field
                clearable
                v-model="queryRequest.warehouseName"
                label="仓库名称"
                single-line/>
          </v-col>

          <v-col
              cols="2">
            <v-text-field
                clearable
                v-model="queryRequest.hospName"
                label="关联医院"
                single-line/>
          </v-col>
          <v-col
              cols="2">
            <z-source-selector label="状态"
                               v-model="queryRequest.state"
                               source="DicSelector" param="WAREHOUSE_STATE"/>
          </v-col>

          <v-col
              cols="5">
            <v-btn
                color="primary"
                :loading="loading"
                @click="queryPageQuery">
              搜索
              <v-icon right>mdi-magnify</v-icon>
            </v-btn>
            <v-btn
                color="primary"
                class="ma-2"
                @click="resetQuery">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <v-btn color="primary"
                   @click="addProject">添加仓库
            </v-btn>
          </v-col>

        </v-row>
      </v-form>
    </v-row>

    <v-row justify="center">
      <v-col :cols="10">

        <v-treeview
            v-if="treeList.length>0"
            class="ml-12 mr-12"
            v-model="treeKeyList"
            activatable
            dense
            item-key="id"
            item-text="nodeName"
            item-children="hospInfos"
            :items="treeList"
            return-object
            @update:active="updateActiveKey"
            open-all
        >
          <template v-slot:append="{ item, open }">

            <div class="d-flex justify-end align-center">
              <div class="mr-10 px-5" v-show="item.wmsAdminListDesc">
                <div>{{ item.wmsAdminListDesc }}</div>
              </div>
              <div style="padding:0 20px;"
                   v-show="item.state">
                <div v-if="item.state === '00'" style="color:green;">{{ item.stateDesc }}</div>
                <div v-else style="color:red;">{{ item.stateDesc }}</div>
              </div>
              <div style="width:300px;text-align: right">
                <v-btn color="primary" v-show="item.state" small @click="addHospital(item)">
                  添加关联医院
                </v-btn>
                <v-btn small class="ml-2 mr-2" @click="edit(item)" color="primary">
                  编辑
                </v-btn>
                <v-btn small color="primary" v-show="item.state&&item.state === '00'"
                       @click="toggleState(item,'确定停用吗?')">
                  停用
                </v-btn>
                <v-btn small color="primary" v-show="item.state && item.state === '99'"
                       @click="toggleState(item,'确定启用吗?')">
                  启用
                </v-btn>
                <v-btn small color="primary"
                       v-show="!item.state"
                       @click="deleteNode(item)">
                  删除
                </v-btn>
              </div>
            </div>

          </template>
        </v-treeview>
        <h4 v-else
            class="text-center">暂无数据~</h4>

        <!--                <v-pagination v-model="page"  :length="wmsLength"-->
        <!--                              prev-icon="mdi-menu-left" next-icon="mdi-menu-right">-->

        <!--                </v-pagination>-->
      </v-col>
    </v-row>

    <!--新增目录弹框 start-->
    <v-dialog
        v-model="dialog.addWms"
        max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">添加仓库</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-form
                    v-model="addWmsFormValid"
                    ref="addWmsForm">
                  <v-text-field label="仓库名称"
                                clearable
                                v-model="addWmsForm.warehouseName"
                                :rules="[v => !!v || '名称必填']"
                                required/>
                  <z-source-selector
                      clearable
                      v-model="addWmsForm.wmsAdminList"
                      hide-details="auto"
                      multiple
                      single-line
                      source="WmsAdminSelector"
                      label="仓库管理人员"/>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn
              color="primary"
              text
              @click="dialog.addWms=false">
            取消
          </v-btn>
          <v-btn color="primary"
                 :disabled="!addWmsFormValid"
                 @click="confirmAddWms">提交
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--新增目录弹框 end-->

    <!--新增关联医院 start-->
    <v-dialog
        v-model="dialog.addHospital"
        max-width="60%">
      <v-card>
        <v-card-title>添加关联医院</v-card-title>
        <v-card-text>
          <div>
            仓库名称：
            <span>{{ addHospitalReq.warehouseName }}</span>
          </div>
          <v-form ref="queryHospForm">
            <v-row justify="center" align="center">
              <v-col cols="3">
                <v-text-field clearable v-model="queryHospData.hospName"
                              label="医院名称" single-line/>
              </v-col>

              <v-btn color="primary" :loading="queryHospRequestLoading" @click="handleHospQuery">
                搜索
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
              <v-btn color="primary" class="ma-2" @click="resetHospQuery">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

            </v-row>
          </v-form>
          <v-row justify="center">
            <v-col cols="10">
              <v-data-table
                  :options.sync="hosplistOptions"
                  :server-items-length="hospTotal"
                  v-model="selectedHosp"
                  :headers="hospHeaders"
                  :items="hospList"
                  :single-select="false"
                  item-key="id"
                  show-select
                  class="elevation-1"/>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn color="primary" text @click="dialog.addHospital=false">
            取消
          </v-btn>
          <v-btn color="primary" @click="submitHospital">提交
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!--新增关联医院 end-->

    <v-dialog v-model="editDialog"
              max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">编辑</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-form v-model="editFormValid" ref="editForm">
                  <v-col cols="12">
                    <v-text-field label="名称" clearable v-model="editForm.name"
                                  :rules="[v => !!v || '名称必填']" required/>
                  </v-col>
                  <v-col cols="12">
                    <z-source-selector
                        v-show="editForm.state"
                        v-model="editForm.wmsAdminList"
                        hide-details="auto"
                        multiple clearable
                        single-line
                        source="WmsAdminSelector"
                        label="仓库管理人员"/>
                  </v-col>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn color="primary" text @click="editDialog=false">
            取消
          </v-btn>
          <v-btn color="primary" :disabled="!editFormValid" @click="confirmEdit">提交</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <z-notify ref="notify"></z-notify>

    <z-confirm msg="确定删除吗?"
               @confirm="confirmDelet"
               v-model="dialog.isShowConfirmDialog"></z-confirm>

    <z-confirm :msg="toggleStateMsg"
               @confirm="confirmToggle"
               v-model="dialog.isShowToggleStateDialog"></z-confirm>


  </v-container>
</template>

<script>
import {
  pageQuery,
  addWms,
  updWms,
  updStatusWms,
  pageQueryHosp,
  addRelHosp,
} from '@/api/wmsManagement'
import {updHosp, delHosp} from '@/api/hospInfo'

export default {
  name: "WmsManagement",
  data() {
    return {
      toggleStateMsg: '',
      editDialog: false,
      queryRequest: {
        id: "",
        pagedQueryInfo: {
          index: 1,
          pageSize: 999999
        },
        warehouseName: "",
        state: "",
        hospName: "",
      },
      treeKeyList: [],
      dialog: {
        addWms: false,
        isShowConfirmDialog: false,
        addHospital: false,
        isShowToggleStateDialog: false
      },
      addOneLevelForm: {
        chargeTypeName: '',
        price: 0
      },
      addWmsFormValid: false,
      addWmsForm: {
        warehouseName: '',
        wmsAdminList: [],
      },
      stepValue: 1,
      addChildForm: {
        partCode: '',
        chargeTypeId: '',
        chargeTypeName: '',
        price: 0

      },
      stepChildValue: 1,
      treeList: [],
      total: 0,
      activeKey: [],
      loading: false,
      editFormValid: false,
      //修改仓库状态-id
      updStatusWmsId: '',
      editForm: {
        id: '',
        name: '',
        state: '',
        wmsAdminList: [],
      },
      queryHospRequestLoading: false,
      queryHospData: {
        hospName: '',
        pagedQueryInfo: {
          index: 1,
          pageSize: 15
        }
      },
      hosplistOptions: {},
      hospTotal: 0,
      selectedHosp: [],
      hospHeaders: [
        {
          text: '医院编号',
          align: 'start',
          sortable: false,
          value: 'hospCode',
        },
        {
          text: '医院名称',
          align: 'start',
          sortable: false,
          value: 'hospName',
        }
      ],
      hospList: [],
      addHospitalReq: {
        id: "",
        warehouseName: "",
        hospVOList: []
      },
      //删除医院
      delHospId: '',
      page: 1,
      wmsLength: 0,
    }
  },
  created() {
    this.queryPageQuery();
  },
  watch: {
    hosplistOptions: {
      handler(val, old) {
        console.log(val, '医院的hosplistOptions分页');
        if (val.itemsPerPage == -1) {
          this.queryHospData.pagedQueryInfo.index = 1;
          this.queryHospData.pagedQueryInfo.pageSize = 999999;
        } else {
          this.queryHospData.pagedQueryInfo.index = val.page;
          this.queryHospData.pagedQueryInfo.pageSize = val.itemsPerPage;
        }
        this.handleHospQuery();
      }
    },
    page: {
      handler(val, old) {
        console.log(val, '仓库分页');
        this.queryRequest.pagedQueryInfo.index = this.page;
        this.queryPageQuery();
      }
    }
  },
  methods: {
    //查询 start
    queryPageQuery() {
      this.loading = true;
      pageQuery(this.queryRequest).then(res => {
        this.treeList = JSON.parse(JSON.stringify(res.list).replace(/warehouseName/g, 'nodeName').replace(/hospName/g, 'nodeName'));
        this.total = res.total;
        // this.wmsLength = (this.total / this.queryRequest.pagedQueryInfo.pageSize) +
        //     (this.total % this.queryRequest.pagedQueryInfo.pageSize > 1 ? 1 : 0);
        this.loading = false
      }).catch(err => {
        this.loading = false
      });
    },
    resetQuery() {
      this.$refs.queryForm.reset();
      this.queryPageQuery();
    },
    //查询 end

    //仓库添加 start
    addProject() {
      this.dialog.addWms = true;
    },
    confirmAddWms() {
      let _this = this;
      if (_this.addWmsFormValid) {
        addWms(_this.addWmsForm).then(res => {
          _this.dialog.addWms = false;
          _this.addWmsForm = {
            warehouseName: '',
            wmsAdminList: [],
          }
          _this.queryPageQuery();
          _this.$refs.notify.show("仓库添加成功", {timeout: 1000, color: 'success'});
        }).catch(err => {

        })
      }
    },
    //仓库添加 start

    //编辑仓库/医院名称 begin
    edit(item) {
      if (item.id) {
        this.editForm.id = item.id;
      } else {
        this.editForm.id = item.hospId;
      }
      this.editForm.name = item.nodeName;
      this.editForm.state = item.state;
      this.editForm.wmsAdminList = item.wmsAdminList;
      this.editDialog = true;
    },
    confirmEdit() {
      let _this = this;
      if (_this.editFormValid) {
        if (_this.editForm.state) {
          let req = {
            id: _this.editForm.id,
            warehouseName: _this.editForm.name,
            wmsAdminList: _this.editForm.wmsAdminList,
          }
          updWms(req).then(res => {
            _this.editDialog = false;
            _this.queryPageQuery();
            _this.$refs.notify.show("仓库信息修改成功", {timeout: 1000, color: 'success'});
          }).catch(err => {
            _this.editDialog = false;
          })
        } else {
          let req = {
            hospId: _this.editForm.id,
            hospName: _this.editForm.name,
          }
          updHosp(req).then(res => {
            _this.editDialog = false;
            _this.queryPageQuery();
            _this.$refs.notify.show("医院名称修改成功", {timeout: 1000, color: 'success'});
          }).catch(err => {
            _this.editDialog = false;
          })
        }
      }
    },
    //编辑仓库名称 end

    //修改仓库状态 begin
    toggleState(item, msg) {
      this.toggleStateMsg = msg;
      this.updStatusWmsId = item.id;
      this.dialog.isShowToggleStateDialog = true;
    },
    confirmToggle() {
      let reqData = {
        id: this.updStatusWmsId
      };
      updStatusWms(reqData).then(res => {
        this.dialog.isShowToggleStateDialog = false;
        this.queryPageQuery();
        this.$refs.notify.show("仓库信息修改成功", {timeout: 1000, color: 'success'});
      }).catch(err => {

      })
    },
    //修改仓库状态 end

    //添加关联医院 begin
    addHospital(item) {
      this.addHospitalReq.id = item.id;
      this.addHospitalReq.warehouseName = item.nodeName;
      this.selectedHosp = [];
      this.dialog.addHospital = true;
    },
    submitHospital() {
      if (this.selectedHosp.length < 1) {
        this.$refs.notify.show("请至少选择一个医院", {timeout: 1000, color: 'error'});
      } else {
        this.addHospitalReq.hospVOList = []
        this.selectedHosp.forEach(item => {
          let hospInfo = {
            id: item.id,
            hospCode: item.hospCode,
            hospName: item.hospName
          };
          this.addHospitalReq.hospVOList.push(hospInfo);
        })
        addRelHosp(this.addHospitalReq).then(res => {
          this.dialog.addHospital = false;
          this.queryPageQuery();
          this.$refs.notify.show("关联医院添加成功", {timeout: 1000, color: 'success'});
        }).catch(err => {
          this.dialog.addHospital = false;
        })
      }
    },

    //医院查询
    handleHospQuery() {
      this.queryHospRequestLoading = true;
      pageQueryHosp(this.queryHospData).then(res => {
        this.hospList = res.list;
        this.hospTotal = res.total;
        this.queryHospRequestLoading = false;
      }).catch(err => {
        this.queryHospRequestLoading = false;
      });
    },
    //重置
    resetHospQuery() {
      // alert("重置查询条件");
      this.queryHospData.pagedQueryInfo.index = 1;
      this.$refs.queryHospForm.reset();
      this.handleHospQuery();
    },

    //医院删除
    deleteNode(item) {
      this.delHospId = item.hospId;
      this.dialog.isShowConfirmDialog = true;
    },
    confirmDelet() {
      var reqData = {
        hospId: this.delHospId
      };
      delHosp(reqData).then(res => {
        this.dialog.isShowConfirmDialog = false;
        this.queryPageQuery();
        this.$refs.notify.show("删除医院成功", {timeout: 1000, color: 'green'});
      }).catch(err => {
        this.dialog.isShowConfirmDialog = false;
      });
    },

    //添加医院 end

    updateActiveKey(list) {
      this.activeKey = list[0];
      console.log(this.activeKey, '当前激活的节点');
    },

    // submit() {
    //     if (this.$refs.chargeMoneyForm.validate()) {
    //         this.addOneLevelForm.price = this.addOneLevelForm.price * 1;
    //         addWms(this.addOneLevelForm).then(res => {
    //             this.dialog.addWms = false;
    //             this.$refs.notify.show("添加成功", {timeout: 1000, color: 'green'});
    //         }).catch(err => {
    //
    //         });
    //     }
    // },
    // goNextStep() {
    //     if (this.$refs.chargeNameForm.validate()) {
    //         this.stepValue++;
    //     }
    // },
    // goChildNodeNextStep() {
    //     if (this.$refs.chargeChildNameForm.validate()) {
    //         this.stepChildValue++;
    //     }
    // },
    // submitChildNode() {
    //     if (this.$refs.chargeMoneyChildForm.validate()) {
    //         this.addChildForm.price = this.addChildForm.price * 1;
    //         console.log(this.addChildForm, 'this.addChildForm');
    //         addDetail(this.addChildForm).then(res => {
    //             this.dialog.addHospital = false;
    //             this.$refs.notify.show("添加成功", {timeout: 1000, color: 'green'});
    //             this.queryPageQuery();
    //         }).catch(err => {
    //
    //         })
    //     }
    // },


  }
}
</script>

<style scoped>

</style>
